import { Component } from '@angular/core';
import { ListComponent } from 'src/app/common/component/list.component';

@Component({
	selector: 'app-decription-header-list',
	templateUrl: './decription-header-list.component.html',
	styleUrls: ['./decription-header-list.component.css'],
})
export class DecriptionHeaderListComponent extends ListComponent {
	protected apiUrl = 'description_header';
	protected apiType = 'bag';
	codebook;
	title: string;
	tableRows = [
		{ id: 'name', name: 'Nazwa' },
		{ id: 'header', name: 'Angielska nazwa' },
		{
			id: 'comment',
			name: 'Treść "dymka", podpowiedź podczas wprowadzania opisów',
		},
	];

	filters = {
		limit: 9999,
	};

	protected loadBefore(): void {
		this.bag.get('/codebook/3/', (result, error) => {
			this.codebook = result;
			this.title = `Słowniki -> ${this.codebook.name}`;
			this.loadData();
		});
	}
}
